import { AppConfigState } from './app-config.state';
import { AppState } from './app.state';
import { DeepLinkingParamsState } from './deep-linking-params.state';
import { DemographicsState } from './demographics.state';
import { DrugsState } from './drugs.state';
import { GoogleTagManagerState } from './google-tag-manager.state';
import { PharmaciesState } from './pharmacies.state';
import { PlansState } from './plans.state';
import { RuntimeState } from './runtime.state';

export const ALL_STORE_STATES = [
  AppConfigState,
  AppState,
  DemographicsState,
  DrugsState,
  PharmaciesState,
  PlansState,
  RuntimeState,
  GoogleTagManagerState,
  DeepLinkingParamsState
];
